<template>
    <main :class="{'main':true, 'with-timetable':true, 'locked': locked }">

    </main>
</template>

<script>
  export default {
    name: 'TimeTableSummary',
    data: function () {
      return {
        loading: false,
        selectedDate: this.$route.params.date ? this.$moment(this.$route.params.date, 'YYYY-M-D').toDate() : this.$moment.utc().toDate(),
        appointments: [],
        employees: [],
        weekDay: null
      }
    },
    created () {
      this.getAppointments()
    },
    methods: {
      getAppointments () {
        this.loading = true
        this.appointments = []
        let selectDate = this.$moment(this.selectedDate).format('YYYY-MM-DD')
        this.$api.get('/v1/appointments?date=' + selectDate).then(response => {
          this.weekDay = response.data.data.weekDay
          this.employees = response.data.data.employees
          this.appointments = response.data.data.appointments
          this.loading = false
        }).catch(error => {
          console.error(error)
          this.loading = false
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Table/Summary.vue